import { API, Auth } from 'aws-amplify';

export async function emailMarketing(action, payload = {}) {
  const session = await Auth.currentSession();
  const token = session.getIdToken().getJwtToken();
  return API.post('apiemailmarketing', '/emailMarketing', {
    body: { action, ...payload },
    headers: { Authorization: `Bearer ${token}` },
  });
}

export const blankEmail = {
  subject: '', preview: '', heading: '', body: '', imageUrl: '', ctaLabel: '', ctaUrl: '',
};

export const emailAudiences = [
  ['all', 'All confirmed members'],
  ['never_purchased', 'Never purchased'],
  ['recent', 'Recently registered (30 days)'],
  ['inactive', 'Last login over 60 days ago'],
  ['active', 'Active paying members'],
  ['failed_payment', 'Failed payments'],
  ['canceled', 'Canceled members'],
  ['former', 'Former paying members'],
];
